import { render, staticRenderFns } from "./myQuan.vue?vue&type=template&id=d0c64ec2&scoped=true"
import script from "./myQuan.vue?vue&type=script&lang=js"
export * from "./myQuan.vue?vue&type=script&lang=js"
import style0 from "./myQuan.vue?vue&type=style&index=0&id=d0c64ec2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c64ec2",
  null
  
)

export default component.exports